import {
  TransportationAggregateType,
  OutboxEventStatus,
} from '@rematter/frontend-lib-api-client';

import {
  createQueryAtomFactory,
  QueryAtomResult,
} from '~/shared/providers/api/createQueryAtomFactory';

export type TransportationOutboxEventRecord = QueryAtomResult<
  typeof transportationOutboxEventsQueryAtom
>['events'][number];

export const transportationOutboxEventsQueryAtom = createQueryAtomFactory(
  'auditLog.transportationOutboxEvents',
  (params: {
    aggregateTypes?: TransportationAggregateType[];
    aggregateId?: string;
    statuses?: OutboxEventStatus[];
    createdAtRange?: { start?: string; end?: string };
    pagination?: {
      limit: number;
      offset: number;
    };
  }) => ({
    transportationOutboxEvents: {
      __args: {
        filter: {
          aggregateTypes: params.aggregateTypes,
          aggregateId: params.aggregateId,
          statuses: params.statuses,
          createdAtRange: params.createdAtRange,
        },
        pagination: params.pagination ?? { limit: 50, offset: 0 },
      },
      entries: {
        id: true,
        topic: true,
        eventName: true,
        version: true,
        metadata: {
          id: true,
          topic: true,
          eventName: true,
          aggregateId: true,
          occurredOn: true,
          organizationId: true,
          version: true,
        },
        payload: true,
        status: true,
        retryCount: true,
        lastRetry: true,
        createdBy: true,
        createdByUser: {
          id: true,
          firstName: true,
          lastName: true,
        },
        timestamps: {
          createdAt: true,
          updatedAt: true,
        },
      },
      page: {
        total: true,
        limit: true,
        offset: true,
      },
    },
  }),
  {
    select: ({ transportationOutboxEvents }) => ({
      total: transportationOutboxEvents.page.total ?? 0,
      events: transportationOutboxEvents.entries,
    }),
  },
);
